<template>
  <div v-if="props.value" class="score">
    <div v-if="props.open" class="rating">
      <div
        v-for="i in 5"
        :key="i"
        class="star"
        :class="{ gray: i > props.value / 20 }"
      />
    </div>
    <img v-else src="/static/images/star.svg" alt />
    <div
      v-if="!props.open"
      class="text-body-m-book"
      :itemprop="props.itemprop ? 'ratingValue' : undefined"
    >
      {{ (value / 20).toFixed(1) }}
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  value: {
    type: Number,
  },
  open: Boolean,
  itemprop: Boolean,
});
</script>
<style lang="scss" scoped>
.score {
  color: $achromatic-disabled;
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: flex-start;

  .rating,
  .rating_value {
    height: 12px;

    @include xl-block {
      height: 16px;
    }
  }

  .rating {
    float: left;
    width: 87.75px;
    margin-right: 4px;
    display: flex;
    @include xl-block {
      width: 117px;
      margin-right: 8px;
    }
    .star {
      background: url('/static/images/yellow-star.svg') 100% 100% no-repeat;
      background-size: cover;
      width: 12.75px;
      height: 12px;
      &:not(:last-child) {
        margin-right: 6px;
      }
      @include xl-block {
        width: 17px;
        height: 16px;
      }
    }
    .gray {
      background: url('/static/images/gray-star.svg') 100% 100% no-repeat;
      background-size: cover;
    }
  }

  img {
    flex: 0 0 auto;
    width: 12px;
    margin: 2px 6px 0 0;
    @include xl-block {
      width: 17px;
      margin: 3px 4px 0 0;
    }
  }
}
</style>
